<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { Notification } from '../types/notifications';

const { t } = useI18n();
const { formatDateTime } = useFormatting();

const emit = defineEmits<{
    'notification-click': [Notification]
}>();

const props = defineProps<{
    notification: Notification
}>();

const tableName = computed(() => props.notification.keys.tableName);
const reason = computed(() => props.notification.data.reason ?? t('notifications.customTables.unknownError'));
const errorType = computed(() => props.notification.data.type);

const handleClick = async () => {
    if (tableName.value) {
        await navigateTo({
            name: 'tables-tableName',
            params: { tableName: tableName.value }
        });
    }
    emit('notification-click', props.notification);
};
</script>

<template>
    <div class="cursor-pointer" @click="handleClick">
        <div>
            {{ t('notifications.customTables.indexError', { tableName }) }}
        </div>
        <div v-if="errorType" class="text-sm font-light">
            {{ errorType }}
        </div>
        <div class="text-sm font-light opacity-80">
            {{ reason }}
        </div>
        <div class="flex items-center gap-2 font-light text-sm mt-1">
            <span>{{ formatDateTime(notification.timestamp) }}</span>
            <span class="underline">{{ t('notifications.customTables.viewTable') }}</span>
        </div>
    </div>
</template>
